function generatePie() {
  if($('#pieChartSource').length > 0) {
    $('#pieChartSource').pieChart('#pieChartTarget');
  }
}